import { useGrantCameraAccess } from "@/hooks/tauri/useGrantCameraAccess";
import { useInterceptMediaCommands } from "./useInterceptMediaCommands";
import { usePreventNavigationAndReload } from "./usePreventUserReload";
import { useMoveAppToFolderOnMacOS } from "@/hooks/tauri/useMoveAppToFolder";

export const useInitializeDesktopApp = () => {
  useMoveAppToFolderOnMacOS();
  useInterceptMediaCommands();
  useGrantCameraAccess();
  usePreventNavigationAndReload();
};
